import { createStore } from 'owa-satcheljs';
import type { CopilotTeachingPopoverState } from './schema/copilotTeachingPopoverState';

export const copilotTeachingPopoverStore: () => CopilotTeachingPopoverState =
    createStore<CopilotTeachingPopoverState>('CopilotTeachingPopoverState', {
        sessionId: '',
        title: '',
        body: '',
        visual: '',
        primaryButtonText: '',
        primaryButtonAction: '',
        secondaryButtonText: '',
        secondaryButtonAction: '',
        anchorID: '',
        backgroundColor: '',
        visualAriaLabel: '',
        impressionBaseUri: '',
        irisPrmId: '',
        trackingBaseUri: '',
        cmmId: '',
        isCopilotAcquired: false,
        visible: false,
        rtlHcDarkVisual: '',
        rtlHcVisual: '',
        rtlDarkVisual: '',
        rtlVisual: '',
        hcDarkVisual: '',
        hcVisual: '',
        darkVisual: '',
        prompt: '',
        icon: '',
    });
